module.exports = __webpack_public_path__ + "img/seo-reporter.1a6bc679.jpg";